/*eslint complexity: off*/
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BusinessIcon from '@material-ui/icons/Business';
import Collapse from '@material-ui/core/Collapse';
import Input from '@material-ui/core/Input';
import Request from '~/providers/Request';
import Paper from '~/components/Paper';
import InputControl from '~/components/Input/InputControl';
import InputDate from '~/components/Input/InputDate';
import InputCheckBox from '~/components/Input/InputCheckBox';
import InputSelectAsync from '~/components/Input/InputSelectAsync';
import InputSelect from '~/components/Input/InputSelect';
import Form from '~/containers/Form';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import LinkedDoctors from './LinkedDoctors';
import useStyles from './styles';
import CorporationRecord from '~/records/CorporationRecord';
import { fetchCountries } from '~/utils/fetchCountries';
import { fetchCities } from '~/utils/fetchCities';
import { fetchUsaCities } from '~/utils/fetchUsaCities';
import { fetchFatherCorporations } from '~/utils/fetchFatherCorporations';
import moment from 'moment';
import InputCpfCnpj from '~/components/Input/InputCpfCnpj';
import InputRegex from '~/components/Input/InputRegex';
import InputPhone from '~/components/Input/InputPhone';
import InputNumber from '~/components/Input/InputNumber';
import InputReais from '~/components/Input/InputReais';
import formatPhone from '~/utils/Number/formatPhone';
import currencyJs from 'currency.js';
import Make, { currency, currencyFn } from 'make-currency';

import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from '@material-ui/core';

const BRL = Make.TYPES.BRL;
Make.CONFIGURE({ money: BRL });

const attrName = (attr) => CorporationRecord.hummanAttributeName(attr);

const filters = {
  condition: 'AND',
  groups: [
    {
      condition: 'AND',
      filters: [
        { column: 'owner_partner_id', operation: 'isBlank', value: '' },
      ],
    },
  ],
};

const fetchUsers = async (input, page, resolve) => {
  await Request.get('/admin/users', {
    sorter: 'name.asc',
    qs: input,
    page: page,
    perPage: 50,
    filters: JSON.stringify(filters),
  }).then((resp) => {
    const items = resp.data.map((e) => ({
      id: Number(e.id),
      name: `${e.name}${e.email ? ` <${e.email}>` : ''}`,
    }));
    resolve({
      total_count: resp.meta.total,
      items,
    });
  });
};

function CorporationItem({
  record,
  handleChange,
  onSubmit,
  loading,
  setRecord,
}) {
  const classesRoot = useStyles();
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [packsOptions, setPacksOptions] = useState([]);
  const [requiredConfigCountry, setRequiredConfigCountry] = useState(true);

  const isFranchiseOrInsurance = ['franchise', 'insurance'].includes(record.get('config_corporation').corporation_type);

  const fetchSpecialties = () => {
    Request.get('/admin/specialties', null, { normalizeJSON: false })
      .then((resp) => {
        const items = resp.data
          .filter((e) => e.attributes && e.attributes.is_active === true)
          .map((e) => ({
            id: Number(e.id),
            name: `${e.attributes.name}`,
          }));
        setSpecialtyOptions(items);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  async function fetchPacks() {
    Request.get('/admin/packs', null, { normalizeJSON: true })
      .then((response) => {
        setPacksOptions(response.data);
      })
      .catch((e) => {
        console.log(e);
        setPacksOptions([]);
      });
  }

  useEffect(() => {
    const country = record.get('country').id;
    if (country) {
      if (Number(country) === 2) {
        setRequiredConfigCountry(false);
      } else {
        setRequiredConfigCountry(true);
      }

      if (record.get('phone') && record.get('phone').length > 9) {
        const country = Number(record.get('country').id);
        const formatToFormat = country === 2 ? 'usa' : 'br';
        const clearPhone = record.get('phone').replace(/\D/g, '');
        const newPhone = formatPhone(clearPhone, formatToFormat);
        setRecord(
          record.updateAttributes({
            phone: newPhone,
          })
        );
      }
    }
  }, [record.get('country'), record.get('phone')]);

  async function handleChangeRadioCNS(e) {
    const currentConfig = record.get('config_corporation') || {};
    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...currentConfig,
          required_cns: e.target.value === 'true',
        },
      })
    );
  }

  async function handleChangeRadioDocument(e) {
    const currentConfig = record.get('config_corporation') || {};
    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...currentConfig,
          required_documents: e.target.value === 'true',
        },
      })
    );
  }

  async function handleChangeRadioLocation(e) {
    const currentConfig = record.get('config_corporation') || {};
    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...currentConfig,
          required_location: e.target.value === 'true',
        },
      })
    );
  }

  async function handleChangeRadioBenefitsClub(e) {
    const currentConfig = record.get('config_corporation') || {};
    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...currentConfig,
          has_benefits_club: e.target.value === 'true',
          required_email:
            e.target.value === 'true' ? true : currentConfig.required_email,
        },
      })
    );
  }

  async function handleChangeRadioEmail(e) {
    const currentConfig = record.get('config_corporation') || {};
    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...currentConfig,
          required_email: e.target.value === 'true',
        },
      })
    );
  }
  async function handleChangeAutomaticEmail(e) {
    const currentConfig = record.get('config_corporation') || {};
    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...currentConfig,
          user_welcome_email: e.target.value === 'true',
        },
      })
    );
  }

  // Handlers para os novos campos de franquia/seguradora
  async function handleChangeCorporationType(valueMap) {
    const type = valueMap ? valueMap.corporation_type : null;
    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...record.get('config_corporation'),
          corporation_type: type,
        },
      })
    );
  }

      async function handleChangeUsersLimit({ users_limit }) {
    // Limitar a entrada a 6 caracteres
    let stringValue = users_limit.toString();
    if (stringValue.length > 6) {
      stringValue = stringValue.slice(0, 6);
    }

    let value = parseInt(stringValue) || 1;
    // Garantir que o valor está entre 1 e 100.000
    if (value < 1) value = 1;
    if (value > 100000) value = 100000;

    setRecord(
      record.updateAttributes({
        users_limit: value,
      })
    );
  }

  async function handleChangeNumber({ number }) {
    // Limitar a entrada a 6 caracteres e garantir que seja inteiro
    let stringValue = number.toString().replace(/[^0-9]/g, ''); // Remove tudo que não for dígito
    if (stringValue.length > 6) {
      stringValue = stringValue.slice(0, 6);
    }

    const value = stringValue === '' ? '' : parseInt(stringValue);

    setRecord(
      record.updateAttributes({
        number: value,
      })
    );
  }

  async function handleChangeWalletId({ wallet_id }) {
    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...record.get('config_corporation'),
          wallet_id,
        },
      })
    );
  }

  async function handleChangeLandingUrl({ landing_url }) {
    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...record.get('config_corporation'),
          landing_url,
        },
      })
    );
  }

  async function handleChangeAccessionPercentage({ accession_percentage }) {
    const { floatValue } = currencyFn(accession_percentage);

    if (floatValue > 100) return;

    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...record.get('config_corporation'),
          accession_percentage: floatValue,
        },
      })
    );
  }

  async function handleChangeSignaturePercentage({ signature_percentage }) {
    const { floatValue } = currencyFn(signature_percentage);

    if (floatValue > 100) return;

    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...record.get('config_corporation'),
          signature_percentage: floatValue,
        },
      })
    );
  }

  async function handleChangeIncomeValue({ income_value }) {
    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...record.get('config_corporation'),
          income_value: parseFloat(income_value) || 0,
        },
      })
    );
  }

  // Campos de texto do estabelecimento Mevo (Receita Digital)
  const handleChangeMevoConfig = (field) => (valueMap) => {
    setRecord(
      record.updateAttributes({
        config_corporation: {
          ...record.get('config_corporation'),
          [field]: valueMap[field],
        },
      })
    );
  };

  useEffect(() => {
    fetchSpecialties();
    fetchPacks();

    // Garantir que corporation_type tenha um valor padrão
    const configCorp = record.get('config_corporation') || {};
    if (configCorp.corporation_type === null || configCorp.corporation_type === undefined) {
      setRecord(
        record.updateAttributes({
          config_corporation: {
            ...configCorp,
            corporation_type: null, // null = Cliente
          },
        })
      );
    }
  }, []);

  return (
    <>
      <Form onSubmit={onSubmit}>
        <Paper
          Icon={BusinessIcon}
          iconColor={isPersisted ? 'purple' : 'blue'}
          title={t('corporation.defSingular')}
          loading={loading}
        >
          <div className={clsx(classesRoot.root)}>
            {/* Linha 1: País */}
            <GridContainer spacing={2} style={{ marginBottom: 16 }}>
              <GridItem xs={12} md={6}>
                <InputControl
                  required={true}
                  name={'country'}
                  label={attrName('country')}
                  value={record.get('country')}
                  inputComponent={InputSelectAsync}
                  onChange={handleChange}
                  InputProps={{
                    isClearable: false,
                    handleFetch: fetchCountries,
                    createEnabled: false,
                    error: false,
                  }}
                />
              </GridItem>
            </GridContainer>

            {/* Linha 2: Nome | CNPJ */}
            <GridContainer spacing={2} style={{ marginBottom: 16 }}>
              <GridItem xs={12} md={6}>
                <InputControl
                  required={true}
                  value={record.get('name')}
                  name={'name'}
                  label={attrName('name')}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <InputControl
                  required={requiredConfigCountry}
                  value={record.get('cnpj')}
                  name={'cnpj'}
                  label={attrName('cnpj')}
                  inputComponent={InputCpfCnpj}
                  onChange={handleChange}
                  InputProps={{
                    force: 'cnpj',
                  }}
                />
              </GridItem>
            </GridContainer>

            {/* Linha 3: Email | Telefone | Expiração contrato */}
            <GridContainer spacing={2} style={{ marginBottom: 16 }}>
              <GridItem xs={12} md={4}>
                <InputControl
                  required={true}
                  value={record.get('email')}
                  name={'email'}
                  label={attrName('email')}
                  inputComponent={Input}
                  onChange={handleChange}
                  InputProps={{
                    type: 'email',
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={4}>
                <InputControl
                  required={true}
                  value={record.get('phone')}
                  name={'phone'}
                  label={attrName('phone')}
                  inputComponent={InputPhone}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} md={4}>
                <InputControl
                  required={true}
                  value={moment(record.get('contract_expires_at')).format(
                    'DD/MM/YYYY'
                  )}
                  name={'contract_expires_at'}
                  label={attrName('contract_expires_at')}
                  inputComponent={InputDate}
                  InputProps={{
                    type: 'date',
                    minDate: moment(),
                  }}
                  onChange={(date) =>
                    setRecord(
                      record.updateAttributes({
                        contract_expires_at: moment(date).format(),
                      })
                    )
                  }
                />
              </GridItem>
            </GridContainer>

            {/* Linha 4: Cidade | CEP | Bairro */}
            <GridContainer spacing={2} style={{ marginBottom: 16 }}>
              <GridItem xs={12} md={4}>
                <InputControl
                  required={true}
                  name={'city'}
                  label={attrName('city')}
                  value={record.get('city')}
                  inputComponent={InputSelectAsync}
                  onChange={handleChange}
                  InputProps={{
                    isClearable: false,
                    handleFetch: requiredConfigCountry
                      ? fetchCities
                      : fetchUsaCities,
                    createEnabled: false,
                    error: false,
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={4}>
                <InputControl
                  required={true}
                  value={record.get('postal_code')}
                  name={'postal_code'}
                  label={attrName('postal_code')}
                  inputComponent={InputRegex}
                  onChange={handleChange}
                  InputProps={{
                    mask: requiredConfigCountry
                      ? [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
                      : [
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ],
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={4}>
                <InputControl
                  required={requiredConfigCountry}
                  value={record.get('district')}
                  name={'district'}
                  label={attrName('district')}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>
            </GridContainer>

            {/* Linha 5: Rua | Número | Contato | Telefone Contato | Limite de Usuários | Tipo de Empresa */}
            <GridContainer spacing={2} style={{ marginBottom: 16 }}>
              <GridItem xs={12} md={2}>
                <InputControl
                  required={true}
                  name="street"
                  label={attrName('street')}
                  value={record.get('street')}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} md={1}>
                <InputControl
                  required={true}
                  name="number"
                  label={attrName('number')}
                  value={record.get('number')}
                  inputComponent={Input}
                  onChange={handleChangeNumber}
                  InputProps={{
                    maxLength: 6,
                    inputMode: 'numeric'
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={2}>
                <InputControl
                  required={true}
                  name="contact_name"
                  label={attrName('contact_name')}
                  value={record.get('contact_name')}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} md={2}>
                <InputControl
                  required={true}
                  name="contact_phone"
                  label={attrName('contact_phone')}
                  value={record.get('contact_phone')}
                  inputComponent={InputPhone}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} md={2}>
                <InputControl
                  required={true}
                  name="users_limit"
                  label={attrName('users_limit')}
                  value={record.get('users_limit')}
                  inputComponent={InputNumber}
                  onChange={handleChangeUsersLimit}
                  InputProps={{
                    min: 1,
                    max: 100000,
                    step: 1,
                    precision: 0,
                    maxLength: 6
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={3}>
                 <InputControl
                  required={true}
                  name="corporation_type"
                  label="Tipo de Empresa"
                  value={record.get('config_corporation').corporation_type || null}
                  inputComponent={InputSelect}
                  onChange={handleChangeCorporationType}
                  InputProps={{
                    outValueType: 'string',
                    isClearable: false,
                    placeholder: 'Selecione o tipo de empresa',
                    options: [
                      { id: null, name: 'Cliente' },
                      { id: 'franchise', name: 'Franquia' },
                      { id: 'insurance', name: 'Seguradora' }
                    ],
                  }}
                />
              </GridItem>
            </GridContainer>

            {/* Linha 6: Campos condicionais para franquia/seguradora */}
            <Collapse in={isFranchiseOrInsurance}>
                <GridContainer spacing={2} style={{ marginBottom: 16 }}>
                  <GridItem xs={12} md={2}>
                    <InputControl
                      required
                      name="income_value"
                      label="Renda média mensal"
                      value={record.get('config_corporation').income_value || ''}
                      inputComponent={InputReais}
                      onChange={handleChangeIncomeValue}
                      InputProps={{
                        precision: 2,
                        integerLimit: 7
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={2}>
                    <InputControl
                      required
                      name="accession_percentage"
                      label="Percentual do Split - Taxa de adesão"
                      value={currency(currencyJs(record.get('config_corporation').accession_percentage ?? 0).value, 'INPUT')}
                      inputComponent={Input}
                      onChange={handleChangeAccessionPercentage}
                      InputProps={{
                        placeholder: '0,00',
                        inputProps: {
                          inputMode: 'numeric',
                          pattern: '[0-9]*'
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={2}>
                    <InputControl
                      required
                      name="signature_percentage"
                      label="Percentual do Split - Plano mensal"
                      value={currency(currencyJs(record.get('config_corporation').signature_percentage ?? 0).value, 'INPUT')}
                      inputComponent={Input}
                      onChange={handleChangeSignaturePercentage}
                      InputProps={{
                        placeholder: '0,00',
                        inputProps: {
                          inputMode: 'numeric',
                          pattern: '[0-9]*'
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={3}>
                    <InputControl
                      name="wallet_id"
                      label="ID da conta"
                      value={record.get('config_corporation').wallet_id || ''}
                      inputComponent={Input}
                      onChange={handleChangeWalletId}
                      InputProps={{
                        placeholder: 'Será criado automaticamente',
                        //readOnly: !!record.get('config_corporation').wallet_id,
                        disabled: !!record.get('config_corporation').wallet_id,
                        maxLength: 80
                      }}
                    />
                  </GridItem>
                   <GridItem xs={12} md={3}>
                    <InputControl
                      required={record.get('config_corporation').corporation_type === 'franchise'}
                      name="landing_url"
                      disabled={record.get('config_corporation').corporation_type === 'insurance'}
                      label={attrName('landing_url')}
                      value={record.get('config_corporation').corporation_type === 'insurance' ? '-' : record.get('config_corporation').landing_url || ''}
                      inputComponent={Input}
                      onChange={handleChangeLandingUrl}
                      InputProps={{
                        placeholder: 'Ex: nome_da_empresa',
                        maxLength: 255,
                        ...(record.get('config_corporation').corporation_type === 'insurance' && {
                          disabled: true,
                          sx: {
                            color: '#ccc',
                            opacity: 0.5,
                          }
                        })
                      }}
                    />
                  </GridItem>
                </GridContainer>
            </Collapse>

            {/* Seção de Radio Buttons - Configurações da Empresa */}
            <GridContainer spacing={2} style={{ marginTop: 20 }}>
              <GridItem xs={12} md={2}>
                <Typography
                  style={{
                    fontSize: '14px',
                    color: '#505050',
                    fontWeight: '500',
                    marginBottom: 8,
                  }}
                >
                  {attrName('required_cns')}
                </Typography>
                <RadioGroup
                  name="required_cns"
                  value={record.get('config_corporation').required_cns}
                  aria-label="required_cns"
                  onChange={handleChangeRadioCNS}
                  row
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio color="primary" size="small" />}
                    label="SIM"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" size="small" />}
                    label="NÃO"
                  />
                </RadioGroup>
              </GridItem>
              <GridItem xs={12} md={2}>
                <Tooltip title="Essa obrigação será aplicada para restringir a consulta dos usuários associados a essa empresa, limitando o atendimento ao município onde a empresa está localizada.">
                  <span>
                    <Typography
                      style={{
                        fontSize: '14px',
                        color: '#505050',
                        fontWeight: '500',
                        marginBottom: 8,
                      }}
                    >
                      {attrName('required_location')}
                    </Typography>
                    <RadioGroup
                      name="required_location"
                      value={record.get('config_corporation').required_location}
                      aria-label="required_location"
                      onChange={handleChangeRadioLocation}
                      row
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio color="primary" size="small" />}
                        label="SIM"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio color="primary" size="small" />}
                        label="NÃO"
                      />
                    </RadioGroup>
                  </span>
                </Tooltip>
              </GridItem>
              <GridItem xs={12} md={2}>
                <Typography
                  style={{
                    fontSize: '14px',
                    color: '#505050',
                    fontWeight: '500',
                    marginBottom: 8,
                  }}
                >
                  {attrName('required_documents')}
                </Typography>
                <RadioGroup
                  name="required_documents"
                  value={record.get('config_corporation').required_documents}
                  aria-label="required_documents"
                  onChange={handleChangeRadioDocument}
                  row
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio color="primary" size="small" />}
                    label="SIM"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" size="small" />}
                    label="NÃO"
                  />
                </RadioGroup>
              </GridItem>
              <GridItem xs={12} md={3}>
                <Typography
                  style={{
                    fontSize: '14px',
                    color: '#505050',
                    fontWeight: '500',
                    marginBottom: 8,
                  }}
                >
                  {attrName('has_benefits_club')}
                </Typography>
                <RadioGroup
                  name="has_benefits_club"
                  value={record.get('config_corporation').has_benefits_club}
                  aria-label="has_benefits_club"
                  onChange={handleChangeRadioBenefitsClub}
                  row
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio color="primary" size="small" />}
                    label="SIM"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" size="small" />}
                    label="NÃO"
                  />
                </RadioGroup>
              </GridItem>
              <GridItem xs={12} md={3}>
                <Typography
                  style={{
                    fontSize: '14px',
                    color: '#505050',
                    fontWeight: '500',
                    marginBottom: 8,
                  }}
                >
                  {attrName('required_email')}
                </Typography>
                <RadioGroup
                  name="required_email"
                  value={record.get('config_corporation').required_email}
                  aria-label="required_email"
                  onChange={handleChangeRadioEmail}
                  row
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio color="primary" size="small" />}
                    label="SIM"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" size="small" />}
                    label="NÃO"
                  />
                </RadioGroup>
              </GridItem>
              {parseInt(record.get('country').id) === 2 && (
                <GridItem xs={12} md={12} style={{ marginTop: 10 }}>
                  <Typography
                    style={{
                      fontSize: '14px',
                      color: '#505050',
                      fontWeight: '500',
                      marginBottom: 8,
                    }}
                  >
                    {attrName('user_welcome_email')}
                  </Typography>
                  <RadioGroup
                    name="user_welcome_email"
                    value={record.get('config_corporation').user_welcome_email}
                    aria-label="user_welcome_email"
                    onChange={handleChangeAutomaticEmail}
                    row
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio color="primary" size="small" />}
                      label="SIM"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio color="primary" size="small" />}
                      label="NÃO"
                    />
                  </RadioGroup>
                </GridItem>
              )}
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} md={6}>
                <InputControl
                  name={'corporation'}
                  label={attrName('corporation')}
                  value={record.get('corporation')}
                  inputComponent={InputSelectAsync}
                  onChange={handleChange}
                  InputProps={{
                    isClearable: true,
                    handleFetch: fetchFatherCorporations,
                    createEnabled: false,
                    error: false,
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <InputControl
                  required
                  name={'owners'}
                  label={attrName('owners')}
                  value={record.get('owners')}
                  inputComponent={InputSelectAsync}
                  onChange={handleChange}
                  InputProps={{
                    isClearable: true,
                    handleFetch: fetchUsers,
                    createEnabled: false,
                    isMulti: true,
                    error: false,
                  }}
                />
              </GridItem>
            </GridContainer>
            {/* Seção de Pacotes e Módulos */}
            <GridContainer spacing={2} style={{ marginTop: 24, marginBottom: 16 }}>
              <GridItem xs={12} md={12}>
                <InputControl
                  name={'packs'}
                  label={attrName('packPackages')}
                  value={record.get('packs')}
                  inputComponent={InputSelect}
                  onChange={handleChange}
                  InputProps={{
                    isClearable: true,
                    isMulti: true,
                    options: packsOptions,
                  }}
                />
              </GridItem>
            </GridContainer>

            {/* Checkboxes de Módulos */}
            <GridContainer spacing={2} style={{ marginBottom: 20 }}>
              <GridItem xs={12} md={2}>
                <InputControl
                  value={record.get('is_doctor')}
                  name="is_doctor"
                  label={attrName('is_doctor')}
                  inputComponent={InputCheckBox}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} md={2}>
                <InputControl
                  value={record.get('is_doctor_all')}
                  name="is_doctor_all"
                  label={attrName('is_doctor_all')}
                  inputComponent={InputCheckBox}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} md={2}>
                <InputControl
                  value={record.get('is_emergency')}
                  name="is_emergency"
                  label={attrName('is_emergency')}
                  inputComponent={InputCheckBox}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} md={2}>
                <InputControl
                  value={record.get('is_driving')}
                  name="is_driving"
                  label={attrName('is_driving')}
                  inputComponent={InputCheckBox}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} md={2}>
                <InputControl
                  value={record.get('is_plan')}
                  name="is_plan"
                  label={attrName('is_plan')}
                  inputComponent={InputCheckBox}
                  onChange={handleChange}
                />
              </GridItem>
            </GridContainer>
            <Collapse in={record.get('is_doctor_all')}>
              <GridContainer spacing={2} style={{ marginTop: 16 }}>
                <GridItem xs={12} md={12}>
                  <InputControl
                    name={'specialties'}
                    label={attrName('specialties')}
                    value={record.get('specialties')}
                    inputComponent={InputSelect}
                    onChange={handleChange}
                    InputProps={{
                      isClearable: true,
                      isMulti: true,
                      options: specialtyOptions,
                    }}
                  />
                </GridItem>
              </GridContainer>
            </Collapse>

            <LinkedDoctors
              links={record.get('corporation_doctors') || []}
              specialtyOptions={specialtyOptions.filter(
                (option) =>
                  record.get('is_doctor_all') &&
                  (record.get('specialties') || []).some(
                    (specialty) => Number(specialty.id) === option.id
                  )
              )}
              onChange={(links) => handleChange({ corporation_doctors: links })}
            />

            {/* Receita Digital (Mevo) — dados do estabelecimento */}
            <GridContainer spacing={2} style={{ marginTop: 24, marginBottom: 8 }}>
              <GridItem xs={12} md={12}>
                <Typography
                  style={{ fontSize: '14px', color: '#1976d2', fontWeight: 600 }}
                >
                  Receita Digital (Mevo) — Estabelecimento
                </Typography>
              </GridItem>
            </GridContainer>
            <GridContainer spacing={2} style={{ marginBottom: 16 }}>
              <GridItem xs={12} md={4}>
                <InputControl
                  name="mevo_subparceiro"
                  label="SubParceiro (acordado no KickOff)"
                  value={record.get('config_corporation').mevo_subparceiro || ''}
                  inputComponent={Input}
                  onChange={handleChangeMevoConfig('mevo_subparceiro')}
                />
              </GridItem>
              <GridItem xs={12} md={4}>
                <InputControl
                  name="mevo_estab_nome"
                  label="Nome do estabelecimento"
                  value={record.get('config_corporation').mevo_estab_nome || ''}
                  inputComponent={Input}
                  onChange={handleChangeMevoConfig('mevo_estab_nome')}
                />
              </GridItem>
              <GridItem xs={12} md={4}>
                <InputControl
                  name="mevo_cnes"
                  label="CNES"
                  value={record.get('config_corporation').mevo_cnes || ''}
                  inputComponent={Input}
                  onChange={handleChangeMevoConfig('mevo_cnes')}
                />
              </GridItem>
              <GridItem xs={12} md={4}>
                <InputControl
                  name="mevo_estab_telefone_comercial"
                  label="Telefone comercial"
                  value={
                    record.get('config_corporation').mevo_estab_telefone_comercial || ''
                  }
                  inputComponent={Input}
                  onChange={handleChangeMevoConfig('mevo_estab_telefone_comercial')}
                />
              </GridItem>
              <GridItem xs={12} md={8}>
                <InputControl
                  name="mevo_logo_url"
                  label="Logo URL (162x50px, ≤500kb)"
                  value={record.get('config_corporation').mevo_logo_url || ''}
                  inputComponent={Input}
                  onChange={handleChangeMevoConfig('mevo_logo_url')}
                />
              </GridItem>
            </GridContainer>
          </div>
        </Paper>
      </Form>
    </>
  );
}

CorporationItem.propTypes = {
  record: PropTypes.instanceOf(CorporationRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setRecord: PropTypes.func.isRequired,
};

CorporationItem.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(CorporationItem));
